import type { Branch, BranchApi, Branches, BranchesApi, BranchFilters, BranchFiltersUpdateApi } from '../../models';
import { inlineSearch, paginate } from '../normalize';

// Only active branches are selectable.
const ACTIVE_BRANCH_STATUS = 'ACTIVE';

export const normalizeBranch = (branch: BranchApi): Branch => ({
  ...branch,
  label: branch.branchDesc,
});

export const normalizeBranches = (response: BranchesApi): Branches => {
  const list = (response.items ?? [])
    .filter((branch) => branch.status?.toUpperCase().trim() === ACTIVE_BRANCH_STATUS)
    .map(normalizeBranch);
  return {
    list,
    map: list.reduce(
      (acc, branch) => {
        acc[String(branch.id)] = branch;
        return acc;
      },
      {} as Branches['map'],
    ),
  };
};

export const normalizeBranchFilters = (filters: Partial<BranchFilters>): BranchFiltersUpdateApi => {
  const { search, ...otherFilters } = filters;
  return {
    ...inlineSearch(search),
    ...inlineSearch(otherFilters),
    ...paginate(otherFilters),
  };
};
